export const CONNECTION_LOST = {
  DIALOG_CONTAINER: 'connection-lost-dialog-container',
  CONTENT_CONTAINER: 'connection-lost-content-container',
  ICON_CONTAINER: 'connection-lost-icon-container',
  TITLE_CONTAINER: 'connection-lost-title-container',
  MESSAGE_CONTAINER: 'connection-lost-message-container'
} as const;
